<template>
    <ZebraBreadcrumbCaiot :menuHeader="menuHeader" :menuAside="menuAside"/>
</template>

<script>
    import ZebraBreadcrumbCaiot from './breadcrumb'
    import {mapState} from 'vuex'

    export default {
        components: {
            ZebraBreadcrumbCaiot
        },
        computed: {
            ...mapState({
                menuHeader: state => state.d2admin.menuHeader,
                menuAside: state => state.d2admin.menuAside
            })
        }
    }
</script>
